import React from 'react';
import { useSelector } from 'react-redux';
import s from './barChart.module.scss';
import logo from './img/logo.png';
import locales from '../../../content.json';
import { getParameterFromURL } from '../../../utils/scripts';
import label from './img/label.svg';
import { RootState } from '../../../store';

export const BarChartV4 = () => {
  const puppyBlues = useSelector((state: RootState) => state.data.puppyBlues);
  const darkTheme = getParameterFromURL('darkTheme') === 'true';
  const puppyOnboarding = getParameterFromURL('puppyOnboarding') === 'true';
  const customV52 = getParameterFromURL('config') === 'customV52';

  const data = [
    { title: locales[window.userLang].payment_text_164, column1: 1.3, column2: 1.3 },
    { title: locales[window.userLang].payment_text_165, column1: 1.8, column2: 2.5 },
    { title: locales[window.userLang].payment_text_166, column1: 1.3, column2: 3.5 },
    { title: locales[window.userLang].payment_text_167, column1: 1.9, column2: 4.3 },
  ];

  const title = puppyBlues
    ? locales[window.userLang].payment_text_293
    : puppyOnboarding
      ? locales[window.userLang].payment_text_223
      : customV52
        ? locales[window.userLang].payment_text_264
        : locales[window.userLang].payment_text_162;
  const subtitle = customV52
    ? locales[window.userLang].payment_text_265
    : locales[window.userLang].payment_text_163;

  const division = 5;
  return (
    <div className={s.container}>
      {customV52 && (
        <div className={s.label}>
          <p>{locales[window.userLang].payment_text_263}</p>
          <img src={label} alt="label" />
        </div>
      ) }
      <h2
        className={s.title}
        dangerouslySetInnerHTML={{ __html: title }}
      />
      <p className={s.subtitle}>{subtitle}</p>
      <div className={s.chart}>
        {Array.from({ length: division }, (_, index) => (
          <div key={index} className={s.chartDivision}></div>
        ))}
        <div className={s.chartItemWrapper}>
          {data.map((item, index) => (
            <div className={s.chartItems} key={index}>
              <div
                className={s.chartItem}
                style={{
                  height: `${item.column1 * 36}px`,
                  background: darkTheme ? '#585552' : '#E5DED1',
                }}
              />
              <div
                className={s.chartItem}
                style={{
                  height: `${item.column2 * 36}px`,
                  background: 'linear-gradient(0deg, #C4D200 0%, #00A470 107.8%)',
                }}
              >
                <img className={s.logo} src={logo} alt='Everydoggy' />
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className={s.chartDescription}>
        {data.map((item, index) => (
          <p key={index}>
            {item.title}
          </p>
        ))}
      </div>
      <div className={s.description}>
        <p>{locales[window.userLang].payment_text_58}</p>
        <p>{locales[window.userLang].payment_text_59}</p>
      </div>
    </div>
  );
};
